/* =====================================================================
   pareti-global.js — petits comportements globaux (chargé en defer).
   1. <pr-see-more> : « Mostra di più / Mostra meno » (intro de collection)
   2. Pastilles de couleur des cartes : [data-pr-href] → ouverture de la fiche
   3. Barre d'annonce / de livraison : rotation des messages sur mobile
      ([data-pr-rotate] ; messages = [data-pr-rotate-item] ou .pr-annbar__msg)
   Aucune dépendance, aucun appel réseau. Le JS du cœur Dawn n'est pas modifié.
   ===================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 1. Mostra di più ------------------------------------------------- */
  if (!customElements.get('pr-see-more')) {
    customElements.define(
      'pr-see-more',
      class PrSeeMore extends HTMLElement {
        connectedCallback() {
          this.content = this.querySelector('.pr-see-more__content');
          this.button = this.querySelector('.pr-see-more__toggle');
          if (!this.content || !this.button) return;

          this.max = parseInt(this.dataset.max || '96', 10);
          this.expanded = false;
          this.lastWidth = 0;

          this.onClick = this.toggle.bind(this);
          this.onResize = this.scheduleMeasure.bind(this);
          this.button.addEventListener('click', this.onClick);
          window.addEventListener('resize', this.onResize, { passive: true });

          this.measure();
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(this.measure.bind(this));
          }
        }

        disconnectedCallback() {
          if (this.button) this.button.removeEventListener('click', this.onClick);
          window.removeEventListener('resize', this.onResize);
        }

        scheduleMeasure() {
          var width = this.offsetWidth;
          if (width === this.lastWidth) return;
          this.lastWidth = width;
          window.clearTimeout(this.timer);
          this.timer = window.setTimeout(this.measure.bind(this), 150);
        }

        measure() {
          if (this.expanded) return;
          var full = this.content.scrollHeight;
          // Tolérance d'environ une ligne : on ne replie pas pour cacher 1 ligne.
          if (full <= this.max + 26) {
            this.classList.remove('is-collapsed');
            this.classList.add('is-short');
            this.content.style.maxHeight = '';
            this.button.hidden = true;
          } else {
            this.classList.remove('is-short');
            this.classList.add('is-collapsed');
            this.content.style.maxHeight = this.max + 'px';
            this.button.hidden = false;
          }
        }

        toggle() {
          var content = this.content;
          var self = this;
          this.expanded = !this.expanded;
          this.button.setAttribute('aria-expanded', String(this.expanded));
          this.button.textContent = this.expanded ? this.button.dataset.less : this.button.dataset.more;

          if (this.expanded) {
            this.classList.remove('is-collapsed');
            content.style.maxHeight = content.scrollHeight + 'px';
            var done = function () {
              if (self.expanded) content.style.maxHeight = 'none';
              content.removeEventListener('transitionend', done);
              window.clearTimeout(self.doneTimer);
            };
            if (reduceMotion.matches) {
              done();
            } else {
              content.addEventListener('transitionend', done);
              // Filet de sécurité si transitionend ne se déclenche pas (onglet en arrière-plan…)
              window.clearTimeout(this.doneTimer);
              this.doneTimer = window.setTimeout(done, 450);
            }
          } else {
            content.style.maxHeight = content.scrollHeight + 'px';
            // Force le recalcul avant de replier, pour que la transition se joue.
            void content.offsetHeight;
            content.style.maxHeight = this.max + 'px';
            this.classList.add('is-collapsed');
            var top = this.getBoundingClientRect().top;
            if (top < 0) this.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          }
          this.dispatchEvent(new CustomEvent('pr-see-more:toggle', { bubbles: true, detail: { expanded: this.expanded } }));
        }
      }
    );
  }

  /* 2. Pastilles de couleur des cartes produit ------------------------ */
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-pr-href]');
    if (!target) return;
    var href = target.getAttribute('data-pr-href');
    if (!href) return;
    event.preventDefault();
    event.stopPropagation();
    window.location.href = href;
  });

  /* 3. Barre d'annonce : rotation sur mobile -------------------------- */
  function initRotation(bar) {
    var messages = bar.querySelectorAll('[data-pr-rotate-item], .pr-annbar__msg');
    if (messages.length < 2) return;
    var mobile = window.matchMedia('(max-width: 989px)');
    var index = 0;
    var timer = null;
    var paused = false;

    function show(i) {
      messages.forEach(function (m, n) {
        m.classList.toggle('is-active', n === i);
      });
    }
    function stop() {
      window.clearInterval(timer);
      timer = null;
    }
    function start() {
      stop();
      if (!mobile.matches || reduceMotion.matches || paused) return;
      timer = window.setInterval(function () {
        index = (index + 1) % messages.length;
        show(index);
      }, 4000);
    }

    bar.addEventListener('mouseenter', function () { paused = true; stop(); });
    bar.addEventListener('mouseleave', function () { paused = false; start(); });
    bar.addEventListener('focusin', function () { paused = true; stop(); });
    bar.addEventListener('focusout', function () { paused = false; start(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    var onChange = function () { index = 0; show(0); start(); };
    if (mobile.addEventListener) {
      mobile.addEventListener('change', onChange);
      reduceMotion.addEventListener('change', onChange);
    }
    start();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    document.querySelectorAll('[data-pr-rotate]').forEach(initRotation);
  });
})();
